/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { defaultTo } from 'lodash';
import * as luxon from 'luxon';
export const convertToDateFormatUTC = isoString => {
  return luxon.DateTime.fromISO(isoString).toUTC().toFormat('M/d/yyyy');
};

/**
 * Converts an ISO string, such as "202-03-21T03:59:05.000Z", to the desired format, such as "3/20/2023" be ´default
 * @param isoString
 * @param format
 * @param timezone IANA timezone string, ex: "America/New_York"
 * @returns
 */
export const convertToDateFormat = function (isoString) {
  let format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'M/d/yyyy';
  let timezone = arguments.length > 2 ? arguments[2] : undefined;
  if (!isoString || isoString.length < 1) return '';
  const dateOptions = timezone ? {
    zone: timezone
  } : {};
  return luxon.DateTime.fromISO(isoString, dateOptions).toFormat(format);
};
export const getFormattedDisplay = (timestamp, format) => {
  const dateLuxon = luxon.DateTime.fromMillis(timestamp);
  return dateLuxon.toFormat(defaultTo(format, 'MM/dd/yyyy hh:mm a'));
};
export const getStartOfDateIsoString = (isoString, unit) => {
  return luxon.DateTime.fromISO(isoString).startOf(unit).toISO();
};

/**
 * returns something like '50 minutes ago'
 */
export const getRelativeTimeOfIsoString = isoString => {
  return luxon.DateTime.fromISO(isoString).toRelative();
};
export const getDiffInUnits = (isoStringA, isoStringB, unit) => {
  const dateTimeA = luxon.DateTime.fromISO(isoStringA);
  const dateTimeB = luxon.DateTime.fromISO(isoStringB);
  const resultDuration = dateTimeA.diff(dateTimeB, unit);
  return resultDuration.get(unit);
};
export const truncateByMinute = timestamp => {
  return luxon.DateTime.fromMillis(timestamp).startOf('minute').valueOf();
};
export const convertToISOString = date => {
  if (date instanceof Date) {
    return date.toISOString();
  }
  return date;
};